import create from 'zustand'
import { withImmer, logger } from 'utils/store'
import {
  createLiveTrackingOrderSlice,
  type LiveTrackingOrderSlice,
} from './liveTrackingOrderSlice'

const useLiveTrackingOrderStore = create<LiveTrackingOrderSlice>(
  logger(withImmer(createLiveTrackingOrderSlice), 'MapStore')
)

export { useLiveTrackingOrderStore }
export type { LiveTrackingOrderSlice }
